module.exports = __webpack_public_path__ + "media/cycles-gameplay@xs-92acb9a4e197687707780b9f7bf648c0.gif";